import { vehicleSqftToSizeBucket, unitSqftToSizeBucket } from 'config/units';
import smallUnit from 'assets/images/unit-icons/new/5x5.svg';
import mediumUnit from 'assets/images/unit-icons/new/10x10.svg';
import largeUnit from 'assets/images/unit-icons/new/10x25.svg';
import fiveByTenUnit from 'assets/images/unit-icons/new/5x10.svg';
import fiveByFifteenUnit from 'assets/images/unit-icons/new/5x15.svg';
import tenByFifteenUnit from 'assets/images/unit-icons/new/10x15.svg';
import tenByTwentyUnit from 'assets/images/unit-icons/new/10x20.svg';
import tenByThirtyUnit from 'assets/images/unit-icons/new/10x30.svg';

export function getSizeBucketFromSearchTypeSqft(searchType, sqft) {
	if (searchType === 'vehicle') {
		return vehicleSqftToSizeBucket[sqft];
	}

	return unitSqftToSizeBucket[sqft];
}

export const unitImagesMap = {
	'5x5': smallUnit,
	'5x10': fiveByTenUnit,
	'10x5': fiveByTenUnit,
	
	'5x15': fiveByFifteenUnit,
	'15x5': fiveByFifteenUnit,
	
	'10x10': mediumUnit,
	'10x15': tenByFifteenUnit,
	'15x10': tenByFifteenUnit,

	'10x20': tenByTwentyUnit,
	'20x10': tenByTwentyUnit,

	'10x30': tenByThirtyUnit,
	'30x10': tenByThirtyUnit,
	
	'10x25': largeUnit,
	'25x10': largeUnit,
	default: mediumUnit,
}

export function getUnitImageUrl(length, width) {
	const key = `${length}x${width}`
	return unitImagesMap[key] || unitImagesMap.default;
  }

export default getSizeBucketFromSearchTypeSqft;
